import React from "react";
import { HiArrowRight, HiCheck } from "react-icons/hi";
export default function BestSuit() {
  return (
    <div className="a flex flex-col gap-8 w-[90%] 2xl:w-[70%] mx-auto px-0 mt-24 lg:px-20 md:py-8 ">
      <div className="text-center">
        <h2 className="h2-mb h2-md h2-lg h2-2xl">
          Wählen Sie Ihren Weg –  <br /> <span className="text-[#0b2b40]">flexibel und passend</span>
        </h2>
      </div>


      <div className="flex flex-col gap-6">
        <div className="flex flex-col lg:flex-row gap-6 items-center justify-center">
          {/* Left Card */}
          <div className="w-full z-40 drop-shadow-sm fill-[#D1EFEC] rounded-2xl p-1 bg-gradient-to-b from-[#0b2b40] to-transparent basis-[55%]">
            <div className="bg-gradient-to-b from-[#D1EFEC] via-white/90 to-transparent rounded-2xl flex flex-col gap-4 p-6 lg:p-10">
              <div className="flex flex-col gap-2">
                <p className="flex gap-2 rounded-full px-4 py-2 bg-black text-white font-medium text-sm w-fit">
                  <span>Neu in Deutschland</span>
                </p>
                <div className="flex flex-col gap-1">
                  <h3 className="h3-mb h3-md h3-lg h3-2xl">Einzigartig am Markt
                  </h3>
                  <span className="text-black/60 text-sm lg:text-sm">UNEVA's Bewertungsmanager - Maximale Preisleistung</span>
                </div>
              </div>

              <hr className="bg-black/10 w-full" />

              <div className="flex flex-col gap-4">
                <h3 className="text-xl font-medium">Ihre Vorteile: </h3>
                {[
                  "Negative Bewertung(en) selber in Sekunden melden.",
                  "Kosten nur bei erfolgreicher Löschung durch den Plattformbetreiber.",
                  "Ideal für einzelne oder mehrere Standorte.",
                  "Plattformen entfernen Bewertungen in rund 94 % der Fälle."

                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-5 h-5 bg-green-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                      <HiCheck className="text-sm" />
                    </div>

                    <p className="text-lg">{item}</p>
                  </div>
                ))}
              </div>

              <hr className="bg-black/10 w-full" />

              <div className="flex flex-col gap-4">
                <h3 className="text-xl font-medium">Preis:</h3>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 bg-green-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                    <HiCheck className="text-sm" />
                  </div>

                  <p className="text-lg">Ab 79€ pro Löschung, Zahlung nur bei Erfolg - im Nachgang </p>
                </div>
              </div>

              <hr className="bg-black/10 w-full" />
              <a href="#heroSection"><button className="bg-[#0b2b40] hover:opacity-90 text-white font-bold flex items-center justify-between rounded-full py-3 px-4 w-full">
                <span>Bewertung(en) auswählen</span>
                <span className="bg-white w-8 h-8 rounded-full flex items-center justify-center ml-2">
                  <HiArrowRight className="text-black text-lg" />
                </span>
              </button></a>

            </div>
          </div>

          {/* Right Card */}
          <div className="bg-[#0b2b40]/5 flex flex-col gap-4 p-6 lg:p-10 border border-black/20 rounded-2xl basis-[53%]">
            <div className="flex flex-col gap-2">
              <h3 className="h3-mb h3-md h3-lg h3-2xl">UNEVA's RufBegleiter: Unsere Web-App für mehr Sichtbarkeit und Kontrolle </h3>
              <span className="text-black/60 text-sm lg:text-sm">Zentrale Übersicht aller Bewertungsprofile. Unfaire Bewertungen mit 1-Click zur Löschung veranlassen, Positive Bewertungen automatisiert einholen. </span>
            </div>

            <hr className="bg-black/10 w-full" />

            <div className="flex flex-col gap-4">
              <h3 className="text-xl font-medium">Vorteile:</h3>
              {[
                "Alles an einem Ort – maximale Übersicht und Kontrolle über Ihre Reputation.",
                "Bessere Sichtbarkeit in den Suchergebnissen wie Google.",
                "Automatischer Aufbau positiver Bewertungen.",
                "Mehr Umsatz und Neukunden.",
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-5 h-5 bg-green-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                    <HiCheck className="text-sm" />
                  </div>

                  <p className="text-lg">{item}</p>
                </div>
              ))}
            </div>

            <hr className="bg-black/10 w-full" />

            <div className="flex flex-col gap-4">
              <h3 className="text-xl font-medium">Preis:</h3>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 bg-green-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                  <HiCheck className="text-sm" />
                </div>

                <p className="text-lg">Auf Anfrage</p>
              </div>
            </div>

            <hr className="bg-black/10 w-full" />

            <button className="bg-white hover:opacity-90 text-black font-bold flex items-center justify-between rounded-full border border-black/100 py-3 px-4 w-full text-gray-900 ">

              <span>kostenlose Beratung vereinbaren</span>
              <span className="bg-black w-8 h-8 rounded-full flex items-center justify-center ml-2">
                <HiArrowRight className="text-white text-lg" />
              </span>
            </button>
          </div>
        </div>

        <p className="text-center text-[#666572] text-sm leading-5 max-w-[750px] mx-auto">
          Hinweis: UNEVA führt keine inhaltliche Rechtsprüfung von Bewertungen durch und bietet keine Rechtsberatung. Die Entscheidung über eine Löschung obliegt stets den Plattformbetreibern.
        </p>
      </div>
    </div>
  );
}
